export const isValidDate = (value: string): boolean => {
  if (!value) return false;
  const date = new Date(value);
  return !Number.isNaN(date.getTime());
};

export interface DateErrorMessages {
  invalidDate: string;
  inThePast: string;
  tooSmall: string;
  tooLarge: string;
}

export const dateIsAfterOtherDate = (
  before?: string,
  after?: string,
): boolean => {
  if (!before || !after) return false;
  const d1 = new Date(before);
  const d2 = new Date(after);
  return d2 > d1;
};

export const WithinDateRangeError = {
  invalidDate: "invalidDate",
  inThePast: "inThePast",
  tooSmall: "tooSmall",
  tooLarge: "tooLarge",
} as const;
export type WithinDateRangeError =
  (typeof WithinDateRangeError)[keyof typeof WithinDateRangeError];

export const isWithinDateRange = (
  value: string,
  minDays: number,
  maxDays: number,
  referenceDate: Date | undefined = undefined,
): WithinDateRangeError | undefined => {
  if (maxDays < minDays) {
    throw new Error("Invalid date range");
  }
  if (!isValidDate(value)) {
    return WithinDateRangeError.invalidDate;
  }

  const date = new Date(value);
  if (!referenceDate) {
    referenceDate = new Date();
  }
  referenceDate.setHours(0, 0, 0, 0);
  date.setHours(0, 0, 0, 0);

  const differenceInDays = Math.floor(
    (date.getTime() - referenceDate.getTime()) / 86400000,
  );

  if (differenceInDays < minDays) {
    if (differenceInDays <= 0) {
      return WithinDateRangeError.inThePast;
    } else {
      return WithinDateRangeError.tooSmall;
    }
  }
  if (differenceInDays > maxDays) {
    return WithinDateRangeError.tooLarge;
  }
};

export const isWithinDateRangeTest = (
  value: string,
  minDays: number,
  maxDays: number,
  referenceDate: Date | undefined = undefined,
): boolean => {
  return (
    isWithinDateRange(value, minDays, maxDays, referenceDate) === undefined
  );
};
